import { THttpService } from '@/services/HttpService';

import * as service from './service';

export const getListPurchaseOptionsResponse = async (
  api: THttpService,
  voucherNumber: string,
) => {
  const res = await service.listPurchaseOptions(api, voucherNumber);
  return res;
};
